<template>
    <div class="com-result">
        <div class="com-result__pic">
            <img src="@/assets/icon-hook.svg"/>
        </div>
        <div class="com-result__title">
            信息提交成功，等待管理员审核！
        </div>
        <div class="com-result__description">
            审核结果将在 <code>24小时内</code>，通过邮件发至 <code>{{email}}</code>，感谢您的配合！
        </div>
        <div class="com-result__btn">
            <a href="/merchant/apply?s=0"><button class="com-btn com-btn-submit">返回</button></a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'apply-result',
    data() {
        return {
            email: ''
        } 
    },
    created() {
        this.email = sessionStorage.getItem('email')
    }
}
</script>

<style lang="less" scoped>
    .com-result {
        text-align: center;
        padding: .5rem 0 .2rem;
        &__pic {
            img {
                width: 80px;
            }
        }
        &__title {
            line-height: 3;
            font-size: 14px;
            font-weight: bold;
        }
        &__description {
            line-height: 1.8;
            font-size: .25rem;
            color: #999;
        }
        &__btn {
            margin: .4rem 0;
        }
        .com-btn-submit {
            width: 100px;
            border-radius: 20px;
            margin-top: 20px;
        }
    }
</style>


